<script>
import store from '@state/store'
import { debounce } from 'debounce'
import Layout from '@layouts/loggedin.vue'
import { authComputed } from '@state/helpers'
import AdminTable from '@components/admin-table.vue'
import { GROUPS_TABLE_FIELDS } from '@adminCompanies/constant'

export default {
  components: {
    Layout,
    AdminTable,
  },
  data() {
    return {
      tableFields: GROUPS_TABLE_FIELDS,
    }
  },
  computed: {
    ...authComputed,
    companyId() {
      return this.$route.params.companyId
    },
    page() {
      return this.$store.state.adminGroups.page
    },
    perPage() {
      return this.$store.state.adminGroups.perPage
    },
    lists() {
      return this.$store.state.adminGroups.lists || []
    },
    total() {
      return this.$store.state.adminGroups.total
    },
    loaded() {
      return this.$store.state.adminGroups.loaded
    },
    hasNoData() {
      return !this.lists.length && this.loaded
    },
    loading() {
      return !this.lists.length && !this.loaded
    },
  },
  methods: {
    setPage(params) {
      store.dispatch('adminGroups/setPage', params)
    },
    setFilterParams: debounce(async function setFilterParams(name) {
      await store.dispatch('adminGroups/setFilterParams', name)
    }, 500),
    setSortParams(params) {
      store.dispatch('adminGroups/setSortParams', params)
    },
    goAddItem() {
      this.$router.push({
        name: 'adminGroupsAdd',
        params: { companyId: this.companyId },
      })
    },
    goEditItem(item) {
      this.$router.push({
        name: 'adminGroupsEdit',
        params: {
          companyId: this.companyId,
          groupId: item.id,
          item,
        },
      })
    },
    deleteItem(groupId) {
      store.dispatch('adminGroups/deleteItem', {
        companyId: this.companyId,
        groupId,
      })
    },
  },
}
</script>

<template>
  <Layout>
    <div class="bg-white pt-4 px-8 pb-12 mb-16">
      <AdminTable
        table-type="GROUPS"
        :table-fields="tableFields"
        :total-num="total"
        :list-data="lists"
        :data-loaded="loaded"
        :cur-page="page"
        :per-page="perPage"
        @table-add-item="goAddItem"
        @table-set-sort-params="setSortParams"
        @table-set-filter-params="setFilterParams"
        @table-go-edit-item="goEditItem"
        @table-delete-item="deleteItem"
        @table-set-page="setPage"
      />
    </div>
  </Layout>
</template>
